import { useHasRememberMeCookie } from '@/app/providers/ConfigProvider';
import { useGetMe } from '@/src/api/client';

export const useCurrentUser = (keys: string[] = []) => {
  const hasRememberMeCookie = useHasRememberMeCookie();

  // Pokud hodnota cookie ještě není známá (např. undefined při načítání), tak query ani neaktivuj
  const canFetch = hasRememberMeCookie === true;

  const { data, isLoading, error } = useGetMe({
    query: {
      enabled: canFetch,
      queryKey: ['currentUser', ...keys],
    },
  });

  return {
    currentUser: data?.user,
    isLoading: canFetch ? isLoading : false,
    canFetchUser: canFetch,
    isUserError: !!error,
  };
};
